import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ChatSupportFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M25.693 13.587v1.066c0 .454-.08.88-.2 1.294.027.053-.68 1.133-.68 1.133s-.866 1.493-2.373 1.92c-1.147.32-4.213.32-4.213.32l-4.96.12a.973.973 0 0 0-.387.2l-1.573.933a3.87 3.87 0 0 0 3.866 3.827h6.094c.213 0 .426.08.586.213l4.867 2.894c.12.066.24.093.36.093a.703.703 0 0 0 .707-.707V17a3.85 3.85 0 0 0-2.08-3.413h-.014Z" />
      <Path d="M19.8 4.453H9.173a4.712 4.712 0 0 0-4.72 4.72v12.04a.85.85 0 0 0 .854.854c.146 0 .293-.04.44-.12l5.92-3.52c.2-.174.453-.254.706-.254H19.8a4.72 4.72 0 0 0 4.72-4.72V9.16a4.72 4.72 0 0 0-4.72-4.72v.013Zm-4.173 11.014h-1.814v-5.36h1.814v5.36Zm-.16-6.72c-.214.213-.454.32-.747.32a.988.988 0 0 1-.747-.32 1.01 1.01 0 0 1-.32-.747c0-.293.107-.533.32-.747.214-.213.454-.32.747-.32s.547.107.747.32a.996.996 0 0 1 .306.747c0 .293-.106.533-.306.747Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ChatSupportFilled
